
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/investors/[shortname]/funds/[fundShortname]",
      function () {
        return require("private-next-pages/investors/[shortname]/funds/[fundShortname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/investors/[shortname]/funds/[fundShortname]"])
      });
    }
  